export const DESCRIPTION_UNDER_DOWNLOAD = 'Upload documents up to 25 MB in .pdf format'